import { createAction, props } from "@ngrx/store";
import { RecursivePartial } from "../recursive-partial";
import { ContactState } from "./contact.state";

export const ExtendStateAction = createAction(
    "[Contact Action] Extend State",
    props<{ newState: Partial<ContactState> }>(),
);

export const MergeStateAction = createAction(
    "[Contact Action] Merge State",
    props<{ newState: RecursivePartial<ContactState> }>(),
);

export const InitializeAction = createAction(
    "[Contact Action] Initialize Action",
    props<{ contactId: string }>(),
);

export const PurchaseContactAction = createAction(
    "[Contact Action] Purchase Contact Action",
    props<{ contactId: string }>(),
);


